module.exports = __webpack_public_path__ + "media/KikiCH.55e0455b.mp3";